import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "Error",
  props: [],
  components: {},
  data: function data() {
    return {
      ids: "",
      // 默认选中的角色id
      show: false,
      loading: false,
      title: "",
      abled: true,
      tree: {
        data: [],
        props: {
          children: "children",
          label: "name"
        },
        check: ""
      }
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    // 显示弹框
    dialogShow: function dialogShow(ids) {
      this.title = "选择角色";
      this.show = true;
      this.ids = ids;
      this.getRoleData();
    },
    // 请求角色
    getRoleData: function getRoleData() {
      var _this = this;

      this.loading = true;
      this.$http.get("/web/roleList").then(function (_ref) {
        var data = _ref.data;

        if (data.resCode === 0) {
          var arr = [{
            id: "all",
            name: "全部",
            children: []
          }];
          arr[0].children = data.resData;
          _this.tree.data = arr; // 设置默认选中角色

          _this.$nextTick(function () {
            if (_this.ids) {
              _this.$refs.tree.setCheckedKeys(_this.ids.split(","));

              _this.tree.check = _this.ids.split(",");
              _this.abled = false;
            }
          });
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 触发复选框
    checkFn: function checkFn() {
      var arr = this.$refs.tree.getCheckedKeys();

      if (arr[0] === "all") {
        this.tree.check = "all";
      } else {
        this.tree.check = arr.join(",");
      }

      this.abled = arr.length > 0 ? false : true;
    },
    // 保存选中的角色
    save: function save() {
      var _this2 = this;

      setTimeout(function () {
        _this2.show = false;

        _this2.$message.success("选择成功！");
      }, 500);
    },
    // 获取复选框的值
    getValFn: function getValFn() {
      return this.tree.check;
    }
  },
  watch: {},
  filters: {}
};